import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';

/**
 * Always-visible link to /family. Use in headers alongside (or instead of) ChildSelector
 * so single-child families still have a way to add their second child.
 */
export default function FamilyLink({ className = '' }) {
  return (
    <Link to="/family" data-testid="nav-family"
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium text-slate-600 hover:text-fern hover:bg-fern/5 transition-colors ${className}`}>
      <Users className="w-4 h-4" />
      <span className="hidden sm:inline">Family</span>
    </Link>
  );
}
